
































































import Vue, { PropType } from "vue";
import { Nationality } from "./../../types/dossier/Nationality";
import Multiselect from "vue-multiselect";
import DeleteButton from "./../interface/DeleteButton.vue";
import RequiredLabel from "./../interface/RequiredLabel.vue";

import { RepositoryFactory } from "./../repositories/RepositoryFactory";
const GeographyRepository = RepositoryFactory.get("geography");

export default Vue.extend({
  name: "nationality-input",
  components: { Multiselect, DeleteButton, RequiredLabel },
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    hasType: {
      type: Boolean,
      required: false,
      default: true,
    },
    info: {
      type: String,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
    },
    value: {
      type: Object as PropType<Nationality>,
    },
    required: {
      type: Boolean,
      default: false,
    },
    isDirtyNatio: {
      type: Boolean,
      default: false,
    },
    isDirtyNatType: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      nationalities: [] as Nationality[],
    };
  },
  created() {
    this.getNationaliteiten();
  },
  computed: {
    nationalitiesOnly(): string[] {
      return this.nationalities.map((x) => x.nationaliteit);
    },
    isRequired(): boolean {
      return this.required;
    },
    selectedNationaliteit(): Nationality {
      return this.value;
    },
  },
  methods: {
    async getNationaliteiten() {
      const { data } = await GeographyRepository.getNationaliteiten();
      this.nationalities = data as Nationality[];
    },
    updateNatio(value: string): void {
      this.selectedNationaliteit.nationaliteit = value;
      this.selectedNationaliteit.natCode = (this.nationalities.find(
        (nationality) => {
          return nationality.nationaliteit == value;
        }
      ) as Nationality).natCode;
      this.$emit("input", this.selectedNationaliteit);
    },
    updateNatType(value: string): void {
      this.selectedNationaliteit.natType = parseInt(value);
      this.$emit("input", this.selectedNationaliteit);
    },
    deleteNatio(): void {
      this.$emit("delete-natio");
    },
  },
});
